import React from 'react';
import { Title, Description, Wrapper, DescriptionWrapper, RowStyled } from './RowTitleStyles';
import { CategoryColor } from '../CategoriesBar/CategoriesBarStyles';

export default function RowTitle({
    className, color, text, textColor, description,
}) {
    return (
        <RowStyled className={`${className} w-100`}>
            <Wrapper>
                <CategoryColor color={color} />
                <Title textColor={textColor} color={color}>{text}</Title>
            </Wrapper>
            <DescriptionWrapper>
                <Description color={color}>{description}</Description>
            </DescriptionWrapper>
        </RowStyled>
    );
}
